export default __webpack_public_path__ + "static/media/0015.8ea408b4.png";